import { render } from "./BudgetModal.vue?vue&type=template&id=89a8f250&scoped=true&ts=true"
import script from "./BudgetModal.ts?vue&type=script&lang=ts"
export * from "./BudgetModal.ts?vue&type=script&lang=ts"

import "./BudgetModal.scss?vue&type=style&index=0&id=89a8f250&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a8f250"]])

export default __exports__